import {JOB_STATUS} from "../../../types/models/Job.ts";
import {CUTTER_STATUS} from "../../../types/models/Cutter.ts";
import {LoadingButton} from "@mui/lab";
import {Flare, SignalWifiConnectedNoInternet4} from "@mui/icons-material";
import React, {ReactNode} from "react";
import {IPopulatedJob} from "../../../types/FrontendTypes.ts";

export interface MakeButtonProps {
    job: IPopulatedJob;
    handleStart: () => void;
}

export function MakeButton(props: MakeButtonProps) {
    const {job, handleStart} = props;

    const cutterName = job?.cutter?.name || "Unknown";

    let makeButtonStyle: {
        label?: string,  // If no label is set, the button will default to "Make on <cutter>"
        icon?: ReactNode,
        disabled?: boolean,
        loadingCircleAnimation?: boolean,
        pulsingIconAnimation?: boolean,
        messageIfBusy?: string,
        messageIfOffline?: string
    };

    if ([JOB_STATUS.ANALYSIS_PENDING, JOB_STATUS.ANALYSIS_STARTED].includes(job?.status)) {
        makeButtonStyle = {
            disabled: true,
            loadingCircleAnimation: true,
            label: "Analyzing",
            messageIfBusy: "Waiting for cutter",
            messageIfOffline: "Waiting for cutter"
        };
    } else if ([JOB_STATUS.ANALYSIS_COMPLETE].includes(job?.status)) {
        makeButtonStyle = {
            messageIfBusy: "Cutter is busy",
            messageIfOffline: "Cutter is offline"
        };
    } else if ([JOB_STATUS.EXECUTION_ABORTING].includes(job?.status)) {
        makeButtonStyle = {
            disabled: true,
            loadingCircleAnimation: true,
            label: "Aborting",
        };
    } else {
        makeButtonStyle = {icon: <Flare/>, disabled: true};
    }

    if (makeButtonStyle.messageIfBusy && job?.cutter?.state.isCutterBusy && job?.cutter?.state.jobId != job._id) {
        makeButtonStyle.label = makeButtonStyle.messageIfBusy;
        makeButtonStyle.disabled = true;
        makeButtonStyle.loadingCircleAnimation = true;
    }
    if (makeButtonStyle.messageIfOffline && job.cutter?.status === CUTTER_STATUS.OFFLINE) {
        makeButtonStyle.disabled = true;
        makeButtonStyle.label = makeButtonStyle.messageIfOffline;
        makeButtonStyle.icon = <SignalWifiConnectedNoInternet4/>;
    }

    return <LoadingButton
        key={"makeButton"}
        loading={makeButtonStyle.loadingCircleAnimation || makeButtonStyle.pulsingIconAnimation}
        loadingPosition={"start"}
        disabled={makeButtonStyle.disabled}
        startIcon={makeButtonStyle.icon || <Flare/>}
        onClick={handleStart}
        variant={"contained"}
        color={"secondary"}
    >{makeButtonStyle.label || `Make on ${cutterName}`}</LoadingButton>;
}